import { useState, useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { userData } from '../recoil/atom/userData';
import useGetAllNPSData from './useGetAllNPSData';
import { calculateMonthWiseConsumedMessages } from '../utils/feedbackDataUtils';
import { impersonateData } from '../recoil/atom/impersonate';

const useGetAllMonthlyCounter = () => {
    const user = useRecoilValue(userData);
    const { data } = useGetAllNPSData();
    const impersonate = useRecoilValue(impersonateData);

    const actualUser = impersonate?.impersonate
        ? impersonate.businessDetails
        : user;
    const [totalMonthlyCounter, setTotalMonthlyCounter] = useState(0);
    const [totalMonthlyCounterLimit, setTotalMonthlyCounterLimit] = useState(0);

    useEffect(() => {
        if (data) {
            let total = 0;

            data?.forEach((val) => {
                total += calculateMonthWiseConsumedMessages(
                    val?.feedback,
                    val?.noFeedback,
                    actualUser?.subscriptionStartDate
                );
            });
            setTotalMonthlyCounter(total);
        }
    }, [data]);

    useEffect(() => {
        if (actualUser) {
            let total = 0;
            actualUser?.feedbackTypes?.forEach((val) => {
                total += (actualUser.monthlyLimit?.[val]) ?? 0;
            });
            setTotalMonthlyCounterLimit(total);
        }
    }, [actualUser]);
    return { totalMonthlyCounter, totalMonthlyCounterLimit };
};

export default useGetAllMonthlyCounter;